/**
 * One rule for where a week starts, shared by everything that buckets by week.
 *
 * This lived privately in `api/src/routes/nodes.ts`, which was fine while the
 * server was the only thing that bucketed. It is here because a second chart
 * on the node page now computes weeks of its own, and two week grids on one
 * page that disagree by a day would be the worst kind of wrong: both look
 * plausible, and the bars simply stop lining up with each other.
 *
 * Monday-start, in UTC. UTC and not local time because the server buckets
 * this way and a local reading would drift a bar into the neighbouring week
 * for anyone east or west of Greenwich — the same reasoning `isoWeekNumber`
 * in the web chart's maths already carries.
 */
export function startOfUtcDay(d) {
    return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
}
/** Monday-start ISO week, in UTC. */
export function startOfUtcWeek(d) {
    const day = startOfUtcDay(d);
    const weekday = day.getUTCDay(); // 0 = Sunday .. 6 = Saturday
    const diffToMonday = (weekday + 6) % 7; // Monday -> 0
    day.setUTCDate(day.getUTCDate() - diffToMonday);
    return day;
}
export const DAY_MS = 24 * 60 * 60 * 1000;
export const WEEK_MS = 7 * DAY_MS;
//# sourceMappingURL=weeks.js.map